import(/* webpackMode: "eager" */ "/app/src/app/[locale]/Technology-Digital/page.tsx");
